import Icon from '@/components/data-display/icon';
import { VARIANT as ICON_VARIANT } from '@/components/data-display/icon/icon.types';
import Button from '@/components/inputs/button';
import { VARIANT } from '@/components/inputs/button/button.types';
import VersatileCard from '@/components/integrated/versatile-card';
import Modal, { toggleModal } from '@/components/utilities/modal';
import { Heading } from '@alto-avios/alto-ui';
import styles from './avios-timeline.module.scss';
import { AviosTimelineProperties } from './avios-timeline.types';

const AviosTimeline = (aviosTimelineProperties: AviosTimelineProperties) => {
  if (Object.values(aviosTimelineProperties).some(value => !value)) {
    return null;
  }

  const {
    awardedLabel,
    daysLabel,
    hoursLabel,
    inPendingLabel,
    purchasedLabel,
    todayLabel,
    withinLabel,
    headlineLabel,
    trackedTimelineUnit,
    trackedTimelinePeriod,
    awardedTimelineUnit,
    awardedTimelinePeriod,
    infoModalContent,
    moreInfoLabel,
  } = aviosTimelineProperties;

  const trackedTimeLabel = trackedTimelineUnit === 'h' ? hoursLabel : daysLabel;
  const awardedTimeLabel = awardedTimelineUnit === 'h' ? hoursLabel : daysLabel;
  return (
    <section className={styles['avios-timeline']}>
      <Modal label="avios-timeline" closeOnOutsideClick>
        <VersatileCard {...infoModalContent} />
      </Modal>
      <div className={styles['avios-timeline__headline']}>
        <Heading as="h2" size="xs">
          {headlineLabel}
        </Heading>
        <Button
          variant={VARIANT.Unstyled}
          onClick={() => toggleModal('avios-timeline')}
          aria-label={moreInfoLabel}
        >
          <Icon
            variant={ICON_VARIANT.Info}
            className={styles['avios-timeline__headline__info-icon']}
          />
        </Button>
      </div>
      <div className={styles['avios-timeline__body']}>
        <div>
          <p>{purchasedLabel}</p>
          <p>{todayLabel}</p>
        </div>
        <p className={styles['avios-timeline__body__chevron']}>
          <Icon variant={ICON_VARIANT.ChevronRight} />
        </p>
        <div>
          <p>{inPendingLabel}</p>
          <p className={styles['avios-timeline__body__days-info']}>
            {withinLabel} {trackedTimelinePeriod} {trackedTimeLabel}
          </p>
        </div>
        <p className={styles['avios-timeline__body__chevron']}>
          <Icon variant={ICON_VARIANT.ChevronRight} />
        </p>
        <div>
          <p>{awardedLabel}</p>
          <p className={styles['avios-timeline__body__days-info']}>
            {withinLabel} {awardedTimelinePeriod} {awardedTimeLabel}
          </p>
        </div>
      </div>
    </section>
  );
};

export default AviosTimeline;
